// This hook is to get the access token using the reresh cookie during access token expiry
// or relaoding the site

import { useNavigate } from "react-router-dom";
import axios, { axiosPrivate } from "../utils/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();

  const refresh = async () => {
    const response = await axios.post(
      "/contactcentre/auth/token/refresh/",
      {},
      {
        headers: { 
          "Content-Type": "application/json" ,
          Authorization: `Bearer ${auth?.accessToken} `,
        },
        withCredentials: true,
      },
    );

    const getUserresponse = await axios.post(
      "/contactcentre/auth/agent/",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${response.data.access} `,
        },
        withCredentials: true,
      }
    );
    console.log("user details   ", auth)
    const user_id = getUserresponse.data.user_details?.user
    const autoAnswer = getUserresponse.data.user_details?.autoAnswer
    const autoAnswerInterval = getUserresponse.data.user_details?.autoAnswerInterval
    localStorage.setItem("autoAnswerVisibile", autoAnswer)
    localStorage.setItem("autoAnswerInterval", autoAnswerInterval)
    if(!user_id){
        navigate('/Login');
        return null
      }
    const getPermissionresponse = await axios.get(
      "/contactcentre/contact_permission/" + user_id+"/"
    )


    setAuth((prev) => {
      return {
        ...prev,
        accessToken: response.data.access,
        roles: getUserresponse.data.roles,
        user_details: getUserresponse.data.user_details,
        permissions: getPermissionresponse
      };
    });

    return response.data.access;
  };

  return refresh;
};

export default useRefreshToken;
